import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e0fbf16"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "print-screen-data",
  style: {"visibility":"hidden"}
}, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center"} }, " Page was changed to prevent print screen action!"),
  /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "Please click any where to return the original content")
], -1))
const _hoisted_2 = { class: "center-vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_AppViews = _resolveComponent("AppViews")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_v_btn, {
          class: "full-screen",
          variant: "outlined",
          size: "large",
          color: "black",
          onClick: _ctx.fullScreen
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-resize")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_notifications),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AppViews)
      ])
    ]),
    _: 1
  }))
}